import { AVAILABLE_LANGUAGES, FALLBACK_LANGUAGE, Language } from "@juristic/types/generic/language";
import DA from "@Translations/da.json";
import DE from "@Translations/de.json";
import EN_GB from "@Translations/en-GB.json";
import EN_US from "@Translations/en-US.json";
import ES from "@Translations/es.json";
import FR from "@Translations/fr.json";
import IT from "@Translations/it.json";
import NB from "@Translations/nb.json";
import NL from "@Translations/nl.json";
import PL from "@Translations/pl.json";
import PT from "@Translations/pt.json";
import SV from "@Translations/sv.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
const setDocumentLanguage = (language)=>{
    document.documentElement.lang = language;
};
i18n.use(initReactI18next).init({
    resources: {
        [Language.EN_GB]: {
            translation: EN_GB
        },
        [Language.EN_US]: {
            translation: EN_US
        },
        [Language.DA]: {
            translation: DA
        },
        [Language.SV]: {
            translation: SV
        },
        [Language.NB]: {
            translation: NB
        },
        [Language.PT]: {
            translation: PT
        },
        [Language.DE]: {
            translation: DE
        },
        [Language.ES]: {
            translation: ES
        },
        [Language.NL]: {
            translation: NL
        },
        [Language.FR]: {
            translation: FR
        },
        [Language.IT]: {
            translation: IT
        },
        [Language.PL]: {
            translation: PL
        }
    },
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: [
        ...AVAILABLE_LANGUAGES
    ]
});
setDocumentLanguage(i18n.resolvedLanguage ?? FALLBACK_LANGUAGE);
i18n.on("languageChanged", setDocumentLanguage);
export { i18n };
